<!--设置各列数据对应关系-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>

                <el-button style="margin-left: 100px;" type="warning" size="medium"
                  @click="fillExcelSettings">以前导过Excel,填入以前的设置</el-button>
                <el-button style="margin-left: 10px;" type="warning" size="medium"
                  @click="clearSettings">清除已填入的设置</el-button>
              </div>
            </el-row>
          </div>
        </div>
        <div class="rowTipStyle" style="text-align: center;">
        </div>
        <div style="padding: 10px;">

          <div width="100%">
            <div style="text-align: center;font-size:18px;color:red;margin-bottom: 5px;">
              点击下面表格中的文字可快速设为该列列名.不导入的不要选,点击列名可修改.</div>
            <el-table ref="dataList" :data="showedList" style="width: 100%" empty-text="这里将会显示数据" border
              @header-click="clickHeader" :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="450"
              @cell-click="handleCellClick">
              <el-table-column width="150px" header-align="center" resizable align="center" :key="index"
                :label="header.label" :prop="header.prop" v-for="(header,index) in headList">
                <template slot="header" slot-scope="scope">
                  <div class="columnTitleStyle">
                    <div style="text-decoration: underline;color:lightgray;" v-if="header.label==header.prop">
                      {{header.label}}
                    </div>
                    <div style="font-size:16px;" v-else>
                      <div>
                        <div v-if="header.can_edit==1">
                          <el-tooltip class="item" effect="light" content="允许填表人需要填写或修改本列"><span
                              style="color:red;text-decoration: underline;"><i
                                class="el-icon-edit-outline"></i>{{header.label}}</span></el-tooltip>
                        </div>
                        <div v-else>
                          <el-tooltip class="item" effect="dark" content="禁止修改和填写"><span
                              style="color:black;text-decoration: underline;">{{header.label}}</span></el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div v-if="dataList.length>100">
              <div style="text-align: center;margin: 10px;color:red;">
                注:此处只是预览数据窗口，数据总共{{dataList.length}}条，这里只显示前100条，不影响导入数据的正确性。</div>
            </div>
          </div>

        </div>

      </el-col>
    </el-row>

    <!-- Form -->
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="数据预览" :visible.sync="selectColumnTitleDialogVisible"
      height="50%" width="70%">
      <el-form :model="form">
        <div>

          <div>
            <!--            <div style="color:red;font-size: 18px;margin: 10px;">
              <el-checkbox v-model="ImportStructureAndData" style="color:red;" @change="checkImportStateChange">
                导入结构时包括数据</el-checkbox>
            </div> -->
            <!--            <div>
              <div v-if="import_type=='0'" style="font-size: 18px;color:red;margin-bottom: 10px;">
                您打算用此空表表格收集数据,任何人均可领表填写:</div>
              <div v-else style="font-size: 18px;color:red;margin-bottom: 10px;">
                您打算让填表人领表修正或补充下面的数据,只有下面表格中有数据的人才可以领表填写:</div>
            </div> -->

            <el-table ref="dataList" :data="showedList" style="width: 100%" empty-text="这里将会是填表人填好的数据" border res
              :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="300">
              <el-table-column header-align="center" resizable align="center" :key="index" :label="header.label"
                :prop="header.prop" v-for="(header,index) in previewDataList">
                <template slot="header" slot-scope="scope">
                  <div class="columnTitleStyle">
                    <div v-if="header.can_edit==1">
                      <el-tooltip class="item" effect="light" content="允许填写"><span style="color:red;"><i
                            class="el-icon-edit-outline"></i>{{header.label}}</span></el-tooltip>
                    </div>
                    <div v-else>
                      <el-tooltip class="item" effect="dark" content="不可填写"><span>{{header.label}}</span></el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <!--              <el-table-column label="操作" header-align="center" fixed="right" align="center" width="120"
                v-if="is_import_data==true">
                <template slot-scope="scope">
                  <div>
                    <el-button @click.native.prevent="deleteRow(scope.$index, showedList)" type="text" size="small">
                      <div>删除</div>
                    </el-button>
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </el-form>


      <div v-if="dataList.length>100">
        <div style="text-align: center;margin: 10px;color:red;">
          注:此处只是预览数据窗口，数据总共{{dataList.length}}条，这里只显示前100条，不影响导入数据的正确性。</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <!--表格名称-->
    <el-dialog width="60%" :close-on-click-modal="false" title="输入表格名称" :visible.sync="inputFormNameDialogVisible">
      <div class="colStyle">
        <el-input v-model="form_name" placeholder="输入表格名称" style="100%"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="inputFormNameDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="confrimFormName()">导 入</el-button>
      </div>
    </el-dialog>

    <!--修改表头-->
    <el-dialog width="40%" :close-on-click-modal="false" title="修改列名称" :visible.sync="headLabelDialogVisible">
      <div style="display: flex;align-items: center;">
        <div>数据列名：</div>
        <div style="width: 60%;">
          <el-input v-model="currentHeaderContent" placeholder="输入该列的名称"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="headLabelDialogVisible=false">取 消</el-button>
        <el-button @click="deleteHeaderInfo()" v-if="currentHeaderContent!==''">删 除</el-button>
        <el-button type="primary" @click="confirmHeaderInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <!--是否输入数据确认窗口-->
    <el-dialog width="55%" :close-on-click-modal="false" title="请选择导入表格的用途"
      :visible.sync="importDataConfirmDialogVisible">
      <div style="text-align: left;">
        <div style="font-size:18px;">两种用途,请选择一个:</div>
      </div>
      <div style="font-size:22px;">
        <el-radio-group v-model="import_type" @change="changeImportType">
          <div style="margin: 20px;font-size:16px;">
            <el-radio :label="0">用空表格收集全部数据.填表人需要填写所有列中的数据,任何人均可领表填写.</el-radio>
          </div>
          <div style="margin: 20px;">
            <el-radio :label="1">用有数据的表格收集部分数据.填表人只填写部分数据,只有可以领到表的人才可以填写或修改.</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImportSelector">取 消</el-button>
        <el-button type="primary" @click="nextStepToImport()">下一步</el-button>
      </div>
    </el-dialog>

    <!--选择参数匹配模板-->
    <el-dialog title="自动填入设置" :visible.sync="selectExcelSettingDialogVisible" width="40%">
      <div style="font-size: 18px;font-weight: bold;">本次导入的Excel与哪次导入的格式是一样的？请选择:</div>
      <div style="margin-top:10px;">
        <el-select v-model="selected_settings_index" placeholder="请选择" :popper-append-to-body="false"
          @change="selectSettingChanged()">
          <el-option v-for="(item,index) in excel_settings" :key="item.id" :label="item.query_name" :value="index">
            <span><span style="font-size: 16px;font-weight: bold;"> {{item.query_name}}</span><span>
                {{'(' + item.create_time + ')'}}</span></span>

          </el-option>
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="selectExcelSettingDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="matchFields()">立即填入设置</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'
  import tableItem from './tableItem'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header,
      tableItem
    },
    data() {
      return {
        excel_file: '',
        username: '',
        dataList: [],
        oldList: [],
        showedList: [],
        rawDataList: [],

        headList: [],
        buffered_head_list: [],

        headLabelDialogVisible: false,
        selectedHeaderLabel: '',
        selectedHeaderProp: '',
        currentHeaderContent: '',
        selectedColumnIndex: '',

        previewHeaders: [],
        previewDataList: [],

        ImportStructureAndData: false,

        active: 0,
        isCopyFormName: true,
        isCopyFormComment: false,

        startNum: 1,
        endNum: 2,

        startColumnNum: 1,
        endColumnNum: 2,

        headerPreviewData: [],
        form_titles: [],

        form_name: '',
        form_comment: '',

        options: [],
        column_inputed_value: '',
        selectColumnTitleDialogVisible: false,
        selectColumnNameDialogVisible: false,
        inputFormNameDialogVisible: false,

        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '', // 预览整条记录

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [], // 选中导入字段的实际名称
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        settingColumnVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        // 预览表格的相关数据
        previewColumnLables: [],
        previewTableData: [],

        data_type: ['文本', '数字', '日期', '日期及时间', '单选', '多选', '图片', '视频', '定位'],
        is_optional: ['必须填写', '可以填写'],
        column_types: [],
        selectedColumyType: '',
        currentColumnTitle: '',
        currentColumnDescription: '',
        currentColumnSample: '',
        showColumnSample: false,

        previewHeader: [],
        imageSrc: '',
        excel_src_name: '',
        default_image_url: '/wansearch/images/default_header.png',
        header_image_url: '',
        excel_column_count: 1,
        showRange: false,

        headRange: '',
        previewSuccess: false,

        form_headers: [],
        header_count: 0,

        selectedTypeValue: '',
        dataTypes: [{
            value: '文本',
            label: '可输入任何内容'
          },
          {
            value: '数字',
            label: '只能输入数字'
          }, {
            value: '身份证号',
            label: '只能输身份证号'
          }, {
            value: '手机号',
            label: '只能输手机号'
          }, {
            value: '日期',
            label: 'xxxx年xx月xx日'
          }, {
            value: '年月',
            label: 'xxxx年xx月'
          }, {
            value: '日期时间',
            label: 'xxxx年xx月xx日 xx点xx分'
          }, {
            value: '自动时间',
            label: '自动填入填表时间'
          }, {
            value: '日期范围',
            label: 'xxxx年xx月xx日至xxxx年xx月xx日'
          }, {
            value: '图片',
            label: '上传一张图片'
          }, {
            value: '视频',
            label: '上传一个视频文件'
          }, {
            value: 'Email邮箱',
            label: '电子邮箱地址'
          }, {
            value: '车牌号',
            label: '只能输入车牌'
          }, {
            value: '签名',
            label: '手写签名'
          }, {
            value: '定位',
            label: '自动填写填表人位置'
          }
        ],

        importDataConfirmDialogVisible: false,

        is_import_data: '',
        buffered_datalist: [],
        empty_list: [],

        selectedEditTypeValue: '',
        editTypes: [{
            value: '1',
            label: '允许填表人填写或修改'
          },
          {
            value: '0',
            label: '禁止填表人填写或修改'
          }
        ],

        currentHeaderComment: '',

        import_type: '',


        selectExcelSettingDialogVisible: false,
        excel_settings: [],
        selected_settings_index: '',
        selected_settings: '',

        form_id: '',
        form_name: ''

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.excel_file = this.$route.params.excel_file

      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      this.loadData()
    },
    methods: {
      loadData() {
        let that = this

        var requestUrl = '/wansearch/web/_load_preview_data_ex.jsp'
        // 开启loading

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              excel_file: that.excel_file
            }
          }).then(function(response) {
            // console.log(response.data)

            load.close()


            that.headList = response.data.excel_data.HEADERS
            that.buffered_head_list = response.data.excel_data.HEADERS


            var totalRowNum = response.data.excel_data.TOTAL_ROW_NUM

            that.dataList = response.data.excel_data.EXCEL_ROWS
            that.oldList = that.dataList

            if (totalRowNum < 100) {
              that.showedList = that.dataList
            } else {
              that.showedList = that.dataList.slice(0, 99)
            }

            // that.rawDataList=that.dataList



            if (totalRowNum > 0) {
              // console.log('load headlist', that.headList)

              if (that.dataList.length === 0) {
                // that.$message.error('excel导入错误,请联系客服解决!')

                return
              }

              for(var i=0;i<that.headList.length;i++){
                that.headList[pos].label = 'value'
              }



              that.$refs.dataList.doLayout()
            } else {
              that.$message.error('导入数据条数为0，请检查表格是否为空！')
            }



          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      clickHeader(column, event) {
        console.log(column)

        var pStr = column.property
        var numArr = pStr.match(/\d+/g)
        var indexStr = numArr.join('')
        this.selectedColumnIndex = indexStr

        let prop = column.property
        let label = ''

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            label = this.headList[i].label
            break
          }
        }

        if (this.headList[i].label === this.headList[i].prop) {
          this.currentHeaderContent = ''
          this.currentHeaderComment = ''
          this.selectedTypeValue = ''
          this.selectedEditTypeValue = ''
        } else {
          this.currentHeaderContent = label
          this.selectedTypeValue = this.headList[i].data_type
          this.selectedEditTypeValue = this.headList[i].can_edit
          this.currentHeaderComment = this.headList[i].comment
        }

        // this.selectedHeaderLabel = label
        this.selectedHeaderProp = prop

        this.headLabelDialogVisible = true
      },

      handleCellClick(row, column, cell, event) {

        let prop = column.property
        var pos = 0

        for (var i = 0; i < this.headList.length; i++) {
          if (prop === this.headList[i].prop) {
            pos = i
            this.selectedColumnIndex = pos
            break
          }
        }

        let value = row[prop]

        if (Utils.isEmpty(value)) {
          return
        }

        if (this.headList[pos].label === value) {
          this.headList[pos].label = this.headList[pos].prop
          return
        }

        var msg = '要把"' + value + '"设为本列列名吗？'
        let that = this
        this.$confirm(msg, '提示', {
          confirmButtonText: '设为列名',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.headList[pos].label = value

          that.$message.success(prop + '列名已修改为:“' + value + '”，点击列表头文字可设置更多内容。')

          that.$refs.dataList.doLayout()
        })




    // console.log(column)
  },
  confirmHeaderInfo() {
      if (this.currentHeaderContent === '') {

        this.$message.error('请输入列名称')

        return
      }


      for (var i = 0; i < this.headList.length; i++) {
        if (this.selectedHeaderProp === this.headList[i].prop) {
          this.headList[i].label = this.currentHeaderContent
          this.headList[i].data_type = this.selectedTypeValue
          this.headList[i].can_edit = this.selectedEditTypeValue
          this.headList[i].comment = this.currentHeaderComment

          this.$forceUpdate()
          break
        }
      }

      this.headLabelDialogVisible = false
      this.selectedTypeValue = ''
      this.selectedEditTypeValue = ''
      this.currentHeaderComment = ''
    },

    deleteHeaderInfo() {
      this.currentHeaderContent = ''
      this.currentHeaderComment = ''
      this.selectedTypeValue = ''
      this.selectedEditTypeValue = ''

      this.headList[this.selectedColumnIndex].label = this.headList[this.selectedColumnIndex].prop
      this.headLabelDialogVisible = false
      // this.confirmHeaderInfo()
    },

    fieldNameIsValid() {
      var isValid = true

      for (var i = 0; i < this.headList.length; i++) {
        var currentLabel = this.headList[i].label
        for (var k = i + 1; k < this.headList.length; k++) {
          if (currentLabel === this.headList[k].label) {
            isValid = false
            this.$message.error('“' + currentLabel + '”列名重复,请点击表头修改列名！')
            break
          }
        }
      }
      return isValid
    },

    getDuplicateFieldName() {
      var dFieldName = ''

      for (var i = 0; i < this.headList.length; i++) {
        var currentLabel = this.headList[i].label
        for (var k = i + 1; k < this.headList.length; k++) {
          if (currentLabel === this.headList[k].label) {
            dFieldName = currentLabel
            // this.$message.error('“' + currentLabel + '”列名重复,请点击表头修改列名！')
            break
          }
        }
      }
      return dFieldName
    },

    hasSettingColumnName() {
      var setted = false

      for (var i = 0; i < this.headList.length; i++) {
        if (this.headList[i].prop !== this.headList[i].label) {
          setted = true
          break
        }
      }

      return setted
    },
    nextStep() {
      if (!this.hasSettingColumnName()) {
        this.$message.error('请选择数据列！')
        return
      }

      // this.loadPreviewHeaderData()
      // if (!this.fieldNameIsValid()) {
      //   return
      // }
      var duplicateFieldName = this.getDuplicateFieldName()
      if (!Utils.isEmpty(duplicateFieldName)) {
        this.$message.error('“' + duplicateFieldName + '”列名重复,请点击表头修改列名！')
        return
      }


      this.is_import_data = true
      this.ImportStructureAndData = true

      this.showImportPreview()
    },
    confrimImportDataFormName() {
      this.is_import_data = true
      this.ImportStructureAndData = true
      this.showImportPreview()
    },
    confrimNotImportDataFormName() {
      this.is_import_data = false
      this.ImportStructureAndData = false
      this.showImportPreview()
    },
    showImportPreview() {
      this.previewDataList = []
      this.empty_list = []

      this.buffered_datalist = this.dataList
      console.log(this.buffered_datalist)

      for (var i = 0; i < this.headList.length; i++) {
        if (this.headList[i].prop !== this.headList[i].label) {
          let header = {
            prop: this.headList[i].prop,
            label: this.headList[i].label,
            data_type: this.headList[i].data_type,
            can_edit: this.headList[i].can_edit,
            comment: this.headList[i].comment
          }

          this.previewDataList.push(header)
        }

        var cName = this.headList[i].prop
        let emptyItem = {}
        emptyItem[cName] = ''
        this.empty_list.push(emptyItem)
      }

      if (this.is_import_data === false) {
        this.dataList = this.empty_list
      } else {
        this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
      }

      this.selectColumnTitleDialogVisible = true
    },
    filterList(buffered_datalist, selectHeaderList) {
      let tmpList = []

      for (var i = 0; i < buffered_datalist.length; i++) {
        let row = buffered_datalist[i]
        // console.log('row=', row)

        var tmpstr = ''
        for (var j = 0; j < selectHeaderList.length; j++) {
          var headerName = selectHeaderList[j].prop
          // console.log('header==', selectHeaderList[j].prop)
          var cellValue = '' + row[headerName]
          cellValue = cellValue.trim()
          tmpstr = tmpstr + cellValue
          // console.log(tmpstr)
        }

        if (!Utils.isEmpty(tmpstr)) {
          tmpList.push(row)
        }
      }

      return tmpList
    },
    nextPage() {
      var tmpDataList = JSON.stringify(this.dataList)
      var finalHeaderList = JSON.stringify(this.previewDataList)

      var import_data = '1'


      this.$router.push({
        name: 'excel_data_import_final_step_ex',
        params: {
          dataList: tmpDataList,
          headList: finalHeaderList,
          import_data: import_data,
          form_id: this.form_id,
          form_name: this.form_name
        }
      })
    },
    preStep() {
      if (this.active > 0) {
        this.active = this.active - 1
      }
    },
    back() {
      this.$router.back()
    },

    cancelPreviewSetting() {
      this.previewColumnLables.length = 0
      this.dialogFormVisible = false
      this.previewTableData.length = 0
    },
    closeDialog() {
      this.showRange = false
      this.selectColumnTitleDialogVisible = false
      this.previewSuccess = false
    },
    convertHeader(label) {
      if (label == null || label === 'null') {
        return ''
      } else {
        return label
      }
    },
    deleteRow(index, dataList) {
      dataList.splice(index, 1)


      this.$forceUpdate()
    },
    checkImportStateChange(checked) {
      // console.log(checked)
      if (checked === true) {
        this.dataList = this.filterList(this.buffered_datalist, this.previewDataList)
        this.is_import_data = true
      } else {
        this.dataList = this.empty_list
        this.is_import_data = false
      }

      this.$forceUpdate()
    },
    changeImportType(value) {
      // console.log('****>>>>', value)
      this.dataList = this.oldList
      // if (value === '0') {
      //   this.dataList = this.oldList
      //   // 恢复数据
      // }
    },
    closeImportSelector() {
      this.dataList = this.oldList
      this.importDataConfirmDialogVisible = false
    },
    clearSettings() {
      for (var l = 0; l < this.newColumnNames.length; l++) {
        this.newColumnNames[l] = ''
      }

      this.$forceUpdate()

      this.$message.success('清除成功！')
    },
    fillExcelSettings() {
      // this.newColumnNames[1] ='姓名1'
      // this.$forceUpdate()
      let that = this

      // that.$message.success(that.courseForm.course_type)

      var requestUrl = '/wansearch/web/_load_excel_setting_list.jsp'
      this.axios.get(requestUrl, {
          params: {
            equipment: that.username
          }
        }).then(function(response) {
          // 更新表格的数据


          that.excel_settings = response.data.settings

          if (that.excel_settings.length > 0) {
            that.selectExcelSettingDialogVisible = true
          } else {
            that.$alert('您第一次使用需要手工匹配,以后使用就可以选择啦,辛苦您这次选一下！')
          }


          that.$forceUpdate()

        })
        .catch(function(error) {
          console.log(error)
          that.$message(error)
          that.selectExcelSettingDialogVisible = true
        })


    },
    getSelectedColumnSetting(column_name_prop, columnSettingsArray) {
      var tmpObj = ''
      for (var i = 0; i < columnSettingsArray.length; i++) {
        let column = columnSettingsArray[i]
        if (column_name_prop == column.prop) {
          tmpObj = column
          break
        }
      }

      return tmpObj
    },
    matchFields() {

      this.headList = this.buffered_head_list

      let array = JSON.parse(this.selected_settings)
      for (var i = 0; i < this.headList.length; i++) {
        var prop = '第' + i + '列'
        let tmpColumn = this.getSelectedColumnSetting(prop, array)


        if (tmpColumn == '') {
          // continue
          this.headList[i].label = prop
        } else {
          this.headList[i].label = tmpColumn.label
          this.headList[i].data_type = tmpColumn.data_type
          this.headList[i].can_edit = tmpColumn.can_edit
          this.headList[i].comment = tmpColumn.comment
        }
      }

      this.$nextTick(() => {
        // 初始化表格
        this.$refs.dataList.doLayout();
      })
      this.$forceUpdate()


      this.$message.success('匹配完成！为确保匹配正确，请务必人工核对一遍!')
      this.selectExcelSettingDialogVisible = false

    },
    selectSettingChanged() {

      var index = this.selected_settings_index
      this.selected_settings = this.excel_settings[index].settings

    }

  }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    width: 15px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    /*滚动条的背景区域的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(238, 238, 238, 0.3);
    background-color: #eeeeee;
    /*滚动条的背景颜色*/
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
    background-color: rgb(145, 143, 143);
    /*滚动条的背景颜色*/
  }

  .el-radio /deep/ .el-radio__label {

    font-size: 16px !important;

  }

  .el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }


  /* 设置滚动条宽度和高度 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    /* 横向滚动条 */
    height: 8px;
    /* 纵向滚动条 必写 */
  }

  /* 设置滚动条样式 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/excel_data_preview_ex.vue